import { Box, IconButton, Input } from "@chakra-ui/react"
import type { InputProps } from "@chakra-ui/react"
import { forwardRef, useState } from "react"
import { FiEye, FiEyeOff } from "react-icons/fi"

interface PasswordInputProps extends Omit<InputProps, "type"> {
  startElement?: React.ReactNode
  errors?: Record<string, any>
  type?: string
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ startElement, errors, type: fieldType, ...props }, ref) => {
    const [show, setShow] = useState(false)
    const handleClick = () => setShow(!show)

    const errorKey = fieldType || "password"
    const hasError = errors?.[errorKey]

    return (
      <Box>
        <Box position="relative" w="100%">
          {startElement && (
            <Box
              position="absolute"
              left="12px"
              top="50%"
              transform="translateY(-50%)"
              zIndex={1}
              color="gray.500"
            >
              {startElement}
            </Box>
          )}
          <Input
            ref={ref}
            type={show ? "text" : "password"}
            pl={startElement ? "40px" : undefined}
            pr="40px"
            {...props}
          />
          <IconButton
            aria-label={show ? "Hide password" : "Show password"}
            size="sm"
            onClick={handleClick}
            position="absolute"
            right="8px"
            top="50%"
            transform="translateY(-50%)"
            variant="ghost"
          >
            {show ? <FiEyeOff /> : <FiEye />}
          </IconButton>
        </Box>
        {hasError && (
          <Box color="red.500" fontSize="sm" mt={1}>
            {errors[errorKey].message}
          </Box>
        )}
      </Box>
    )
  },
)

PasswordInput.displayName = "PasswordInput"

export default PasswordInput
